import { IForm } from '@hooks/useForm';
import { ILoading } from '@hooks/useLoading';
import { IStepper } from '@hooks/useStepper';
import { IValueState } from '@hooks/useValueState';
import { ICliente } from '@model/Cliente';
import { IComboClienteTipo } from '@model/ClienteTipo';
import { IComboRemetenteWhatsapp } from '@model/RemetenteWhatsapp';
import { IValidarDocumentoResponse } from '@services/ContratoClienteService';
import React from 'react';
import { PageBox } from '../PageBox';
import { ClienteCommand } from './ClienteCommand';
import { ClienteFormulario } from './ClienteFormulario';
import { ClienteSearch } from './ClienteSearch';

export type HomeContratoClienteProps = {
    stepper: IStepper
    clienteValueState: IValueState<IValidarDocumentoResponse>
    clienteTipoCombo: IComboClienteTipo
    remetenteWhatsappCombo: IComboRemetenteWhatsapp
    form: IForm<Partial<ICliente>>
    loading: ILoading
}

export function HomeContratoCliente ({ 
    stepper,
    clienteValueState,
    clienteTipoCombo,
    remetenteWhatsappCombo,
    form,
    loading,
}: HomeContratoClienteProps) {
    const clienteTipoFieldRef = React.useRef<HTMLInputElement>();

    const setClienteTipoFieldFocus = React.useCallback(() => {
        setTimeout(() => {
            clienteTipoFieldRef.current?.focus();
        }, 300)
    }, []);

    const handleCancel = React.useCallback(() => {
        setClienteTipoFieldFocus();
    }, [setClienteTipoFieldFocus]);

    const searched = clienteValueState.value !== undefined && clienteValueState.value?.cliente !== null;
    const clienteFound = !!clienteValueState.value?.cliente;

    return (
        <React.Fragment>
            <ClienteSearch 
                clienteValueState={clienteValueState}
                clienteTipoCombo={clienteTipoCombo}
                clienteTipoFieldRef={clienteTipoFieldRef}
                form={form}
                loading={loading}
            />

            {
                searched && !clienteFound && (
                    <PageBox>
                        <ClienteFormulario 
                            form={form}
                            remetenteWhatsappCombo={remetenteWhatsappCombo}
                        />
                    </PageBox>
                )
            }
            
            <ClienteCommand
                clienteValueState={clienteValueState} 
                form={form}
                stepper={stepper}
                onCancel={handleCancel}
            />
        </React.Fragment>
    )
}